<form [formGroup]="form" novalidate class="d-flex flex-column gap-3">
  <ap-field
    [title]="'entityType.name' | translate"
    [required]="true"
    [error]="nameField.touched && !!nameField.errors">
    <input appkit-field formControlName="name" [maxLength]="maxNameLength" />
    <div class="ap-field-suggestion">
      {{
        'suggestions.charactersRemaining'
          | translate: { count: maxNameLength - nameField.value.length }
      }}
    </div>
    @if (nameField.touched && nameField.errors?.['required']) {
      <div class="ap-field-validation-error">
        {{ 'formValidations.required' | translate }}
      </div>
    }
    @if (nameField.touched && nameField.errors?.['pattern']) {
      <div class="ap-field-validation-error">
        {{ 'formValidations.lettersRequired' | translate }}
      </div>
    }
  </ap-field>

  <ap-checkbox formControlName="isActive" class="mt-2">
    {{ 'client.isActive' | translate }}
  </ap-checkbox>
</form>
